import React, { lazy, Suspense } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'
import { ConnectedRouter } from 'connected-react-router'
import { CSSTransition, SwitchTransition } from 'react-transition-group'
import { connect } from 'react-redux'

import Layout from 'layouts'

const routes = [
  // Dashboards
  {
    path: '/Dashboard',
    Component: lazy(() => import('pages/dashboard/Dashboard')),
    exact: true,
  },
  // Auth Pages
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
  },
  {
    path: '/auth/register',
    Component: lazy(() => import('pages/auth/register')),
    exact: true,
  },
  {
    path: '/auth/lockscreen',
    Component: lazy(() => import('pages/auth/lockscreen')),
    exact: true,
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404')),
    exact: true,
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500')),
    exact: true,
  },
  // Menu Pages
  // DaroodoSalam
  {
    path: '/DaroodoSalam',
    Component: lazy(() => import('pages/DaroodoSalam')),
    exact: true,
  },
  {
    path: '/Submit-Daroodosalam',
    Component: lazy(() => import('pages/DaroodoSalam/Submit-DaroodoSalam/SubmitDaroodoSalam')),
    exact: true,
  },
  {
    path: '/Halqa-e-Daroodosalam',
    Component: lazy(() => import('pages/DaroodoSalam/Halqa-DaroodoSalam/HalqaDaroodoSalam')),
    exact: true,
  },
  {
    path: '/My-Daroodosalam',
    Component: lazy(() => import('pages/DaroodoSalam/My-DaroodoSalam/MyDaroodoSalam')),
    exact: true,
  },
  // Halqa
  {
    path: '/Halqa',
    Component: lazy(() => import('pages/Halqa')),
    exact: true,
  },
  {
    path: '/Create-New-Halqa',
    Component: lazy(() => import('pages/Halqa/Create-New-Halqa/CreateNewHalqa')),
    exact: true,
  },
  {
    path: '/Joined-Halqa',
    Component: lazy(() => import('pages/Halqa/Joined-Halqa/JoinedHalqa')),
    exact: true,
  },
  {
    path: '/My-Halqa',
    Component: lazy(() => import('pages/Halqa/My-Halqa/MyHalqa')),
    exact: true,
  },
  // Calendar
  {
    path: '/Calendar',
    Component: lazy(() => import('pages/Calendar')),
    exact: true,
  },
  {
    path: '/Hijri-Calendar',
    Component: lazy(() => import('pages/Calendar/Hijri-Calendar/HijriCalendar')),
    exact: true,
  },
  {
    path: '/Gregorian-Calendar',
    Component: lazy(() => import('pages/Calendar/Gregorian-Calendar/GregorianCalendar')),
    exact: true,
  },
  // Maps
  {
    path: '/Maps',
    Component: lazy(() => import('pages/Maps')),
    exact: true,
  },
  {
    path: '/My-Country-Map',
    Component: lazy(() => import('pages/Maps/My-Country-Map/MyCountryMap')),
    exact: true,
  },
  {
    path: '/My-City-Map',
    Component: lazy(() => import('pages/Maps/My-City-Map/MyCityMap')),
    exact: true,
  },
  {
    path: '/Near-Location-Map',
    Component: lazy(() => import('pages/Maps/Near-Location-Map/NearLocationMap')),
    exact: true,
  },
  {
    path: '/Search-Location-Map',
    Component: lazy(() => import('pages/Maps/Search-Location-Map/SearchLocationMap')),
    exact: true,
  },
  // Flags
  {
    path: '/Flags',
    Component: lazy(() => import('pages/Flags')),
    exact: true,
  },
  {
    path: '/My-Flag',
    Component: lazy(() => import('pages/Flags/My-Flag/MyFlag')),
    exact: true,
  },
  // Graphs
  {
    path: '/Graphs',
    Component: lazy(() => import('pages/Graphs')),
    exact: true,
  },
  {
    path: '/Line-Graph',
    Component: lazy(() => import('pages/Graphs/Line-Graph/LineGraph')),
    exact: true,
  },
  {
    path: '/Pie-Graph',
    Component: lazy(() => import('pages/Graphs/Pie-Graph/PieGraph')),
    exact: true,
  },
  {
    path: '/Bar-Graph',
    Component: lazy(() => import('pages/Graphs/Bar-Graph/BarGraph')),
    exact: true,
  },
  {
    path: '/Chart-Graph',
    Component: lazy(() => import('pages/Graphs/Chart-Graph/ChartGraph')),
    exact: true,
  },
  // Prayers Time
  {
    path: '/PrayersTime',
    Component: lazy(() => import('pages/PrayersTime')),
    exact: true,
  },
  {
    path: '/Prayers-Time',
    Component: lazy(() => import('pages/PrayersTime/Prayers-Time/PrayersTime')),
    exact: true,
  },
  {
    path: '/Prayers-Alert',
    Component: lazy(() => import('pages/PrayersTime/Prayers-Alert/PrayersAlert')),
    exact: true,
  },
  // Qibla Direction
  {
    path: '/Qibla-Direction',
    Component: lazy(() => import('pages/Qibla-Direction/QiblaDirection')),
    exact: true,
  },
  // Near Mosque
  {
    path: '/Near-Mosque',
    Component: lazy(() => import('pages/Near-Mosque/NearMosque')),
    exact: true,
  },
  // Wazaif
  {
    path: '/Wazaif',
    Component: lazy(() => import('pages/Wazaif')),
    exact: true,
  },
  {
    path: '/My-Wazaif',
    Component: lazy(() => import('pages/Wazaif/My-Wazaif/MyWazaif')),
    exact: true,
  },
  {
    path: '/Add-New-Wazaif',
    Component: lazy(() => import('pages/Wazaif/Add-New-Wazaif/AddNewWazaif')),
    exact: true,
  },
  // Profile
  {
    path: '/Profile',
    Component: lazy(() => import('pages/Profile')),
    exact: true,
  },
  {
    path: '/My-Stats',
    Component: lazy(() => import('pages/Profile/My-Stats/MyStats')),
    exact: true,
  },
  {
    path: '/Edit-Profile',
    Component: lazy(() => import('pages/Profile/Edit-Profile/EditProfile')),
    exact: true,
  },
  {
    path: '/Logout',
    Component: lazy(() => import('pages/Profile/Logout/Logout')),
    exact: true,
  },
]

const mapStateToProps = ({ settings }) => ({
  routerAnimation: settings.routerAnimation,
})

const Router = ({ history, routerAnimation }) => {
  return (
    <ConnectedRouter history={history}>
      <Layout>
        <Route
          render={state => {
            const { location } = state
            return (
              <SwitchTransition>
                <CSSTransition
                  key={location.pathname}
                  appear
                  classNames={routerAnimation}
                  timeout={routerAnimation === 'none' ? 0 : 300}
                >
                  <Switch location={location}>
                    <Route exact path="/" render={() => <Redirect to="/dashboard" />} />
                    {routes.map(({ path, Component, exact }) => (
                      <Route
                        path={path}
                        key={path}
                        exact={exact}
                        render={() => {
                          return (
                            <div className={routerAnimation}>
                              <Suspense fallback={null}>
                                <Component />
                              </Suspense>
                            </div>
                          )
                        }}
                      />
                    ))}
                    <Redirect to="/auth/404" />
                  </Switch>
                </CSSTransition>
              </SwitchTransition>
            )
          }}
        />
      </Layout>
    </ConnectedRouter>
  )
}

export default connect(mapStateToProps)(Router)
